
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $8f228f84b1e7d967$exports = {};

$parcel$export($8f228f84b1e7d967$exports, "create", () => $8f228f84b1e7d967$export$185802fd694ee1f5);
$parcel$export($8f228f84b1e7d967$exports, "clone", () => $8f228f84b1e7d967$export$9cd59f9826255e47);
$parcel$export($8f228f84b1e7d967$exports, "length", () => $8f228f84b1e7d967$export$f24224f1c91d8156);
$parcel$export($8f228f84b1e7d967$exports, "fromValues", () => $8f228f84b1e7d967$export$a82be99ed2a44a7d);
$parcel$export($8f228f84b1e7d967$exports, "copy", () => $8f228f84b1e7d967$export$784d13d8ee351f07);
$parcel$export($8f228f84b1e7d967$exports, "set", () => $8f228f84b1e7d967$export$adaa4cf7ef1b65be);
$parcel$export($8f228f84b1e7d967$exports, "add", () => $8f228f84b1e7d967$export$e16d8520af44a096);
$parcel$export($8f228f84b1e7d967$exports, "subtract", () => $8f228f84b1e7d967$export$4e2d2ead65e5f7e3);
$parcel$export($8f228f84b1e7d967$exports, "multiply", () => $8f228f84b1e7d967$export$2060d2db72cce88f);
$parcel$export($8f228f84b1e7d967$exports, "divide", () => $8f228f84b1e7d967$export$cd007d971a5a2143);
$parcel$export($8f228f84b1e7d967$exports, "ceil", () => $8f228f84b1e7d967$export$803ce6b71a0a94b2);
$parcel$export($8f228f84b1e7d967$exports, "floor", () => $8f228f84b1e7d967$export$a3fe094919f356fd);
$parcel$export($8f228f84b1e7d967$exports, "min", () => $8f228f84b1e7d967$export$96ec731ed4dcb222);
$parcel$export($8f228f84b1e7d967$exports, "max", () => $8f228f84b1e7d967$export$8960430cfd85939f);
$parcel$export($8f228f84b1e7d967$exports, "round", () => $8f228f84b1e7d967$export$2077e0241d6afd3c);
$parcel$export($8f228f84b1e7d967$exports, "scale", () => $8f228f84b1e7d967$export$dcdf75081b88279d);
$parcel$export($8f228f84b1e7d967$exports, "scaleAndAdd", () => $8f228f84b1e7d967$export$19cedf1da84ba854);
$parcel$export($8f228f84b1e7d967$exports, "distance", () => $8f228f84b1e7d967$export$9f17032d917177de);
$parcel$export($8f228f84b1e7d967$exports, "squaredDistance", () => $8f228f84b1e7d967$export$88e6ebb4fe54f538);
$parcel$export($8f228f84b1e7d967$exports, "squaredLength", () => $8f228f84b1e7d967$export$ab44e1323ffc8376);
$parcel$export($8f228f84b1e7d967$exports, "negate", () => $8f228f84b1e7d967$export$aef51622e549b8b0);
$parcel$export($8f228f84b1e7d967$exports, "inverse", () => $8f228f84b1e7d967$export$70ae2c07e401031b);
$parcel$export($8f228f84b1e7d967$exports, "normalize", () => $8f228f84b1e7d967$export$a3295358bff77e);
$parcel$export($8f228f84b1e7d967$exports, "dot", () => $8f228f84b1e7d967$export$94132a0e348806d4);
$parcel$export($8f228f84b1e7d967$exports, "cross", () => $8f228f84b1e7d967$export$bb646b20bb93d339);
$parcel$export($8f228f84b1e7d967$exports, "lerp", () => $8f228f84b1e7d967$export$3a89f8d6f6bf6c9f);
$parcel$export($8f228f84b1e7d967$exports, "slerp", () => $8f228f84b1e7d967$export$1544d9bc2995de08);
$parcel$export($8f228f84b1e7d967$exports, "hermite", () => $8f228f84b1e7d967$export$ae8865616f30561c);
$parcel$export($8f228f84b1e7d967$exports, "bezier", () => $8f228f84b1e7d967$export$b9c5f84610baddaf);
$parcel$export($8f228f84b1e7d967$exports, "random", () => $8f228f84b1e7d967$export$4385e60b38654f68);
$parcel$export($8f228f84b1e7d967$exports, "transformMat4", () => $8f228f84b1e7d967$export$5ffbd13800309d59);
$parcel$export($8f228f84b1e7d967$exports, "transformMat3", () => $8f228f84b1e7d967$export$f0bfa0a0024626ee);
$parcel$export($8f228f84b1e7d967$exports, "transformQuat", () => $8f228f84b1e7d967$export$c32adef9e939ce85);
$parcel$export($8f228f84b1e7d967$exports, "rotateX", () => $8f228f84b1e7d967$export$a59c8716592e09af);
$parcel$export($8f228f84b1e7d967$exports, "rotateY", () => $8f228f84b1e7d967$export$cf71e4d4ca4d1cfd);
$parcel$export($8f228f84b1e7d967$exports, "rotateZ", () => $8f228f84b1e7d967$export$ea6eae3365de5b9c);
$parcel$export($8f228f84b1e7d967$exports, "angle", () => $8f228f84b1e7d967$export$944b09d2ad10b378);
$parcel$export($8f228f84b1e7d967$exports, "zero", () => $8f228f84b1e7d967$export$7f9972325ebfd559);
$parcel$export($8f228f84b1e7d967$exports, "str", () => $8f228f84b1e7d967$export$42d51816ce590c93);
$parcel$export($8f228f84b1e7d967$exports, "exactEquals", () => $8f228f84b1e7d967$export$f2599a5cf1109d8);
$parcel$export($8f228f84b1e7d967$exports, "equals", () => $8f228f84b1e7d967$export$e9bab7fafb253603);
$parcel$export($8f228f84b1e7d967$exports, "sub", () => $8f228f84b1e7d967$export$f93b5905241a7cca);
$parcel$export($8f228f84b1e7d967$exports, "mul", () => $8f228f84b1e7d967$export$6e3a27864ab166fe);
$parcel$export($8f228f84b1e7d967$exports, "div", () => $8f228f84b1e7d967$export$159d9494db57879b);
$parcel$export($8f228f84b1e7d967$exports, "dist", () => $8f228f84b1e7d967$export$6c4a311cc157c764);
$parcel$export($8f228f84b1e7d967$exports, "sqrDist", () => $8f228f84b1e7d967$export$2422cd6c492a8b3a);
$parcel$export($8f228f84b1e7d967$exports, "len", () => $8f228f84b1e7d967$export$fc1400facf92c78);
$parcel$export($8f228f84b1e7d967$exports, "sqrLen", () => $8f228f84b1e7d967$export$99d8dd3f32a3435);
$parcel$export($8f228f84b1e7d967$exports, "forEach", () => $8f228f84b1e7d967$export$4b80e395e36b5a56);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $b3d72613362f56f7$export$fd293b15f47e270 = 0.000001;
var $b3d72613362f56f7$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $b3d72613362f56f7$export$5ada478c8a628231 = Math.random;
var $b3d72613362f56f7$export$217057687ee20298 = "zyx";
function $b3d72613362f56f7$export$2077e0241d6afd3c(a) {
    if (a >= 0) return Math.round(a);
    return a % 0.5 === 0 ? Math.floor(a) : Math.round(a);
}
function $b3d72613362f56f7$export$cb2c0eb57f5e532c(type) {
    $b3d72613362f56f7$export$b67359430d3b1b2 = type;
}
var $b3d72613362f56f7$var$degree = Math.PI / 180;
var $b3d72613362f56f7$var$radian = 180 / Math.PI;
function $b3d72613362f56f7$export$408b8ee5959eefd5(a) {
    return a * $b3d72613362f56f7$var$degree;
}
function $b3d72613362f56f7$export$c796d9d3e501591f(a) {
    return a * $b3d72613362f56f7$var$radian;
}
function $b3d72613362f56f7$export$e9bab7fafb253603(a, b) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $b3d72613362f56f7$export$fd293b15f47e270;
    return Math.abs(a - b) <= tolerance * Math.max(1, Math.abs(a), Math.abs(b));
}


function $8f228f84b1e7d967$export$185802fd694ee1f5() {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    if ($b3d72613362f56f7$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $8f228f84b1e7d967$export$9cd59f9826255e47(a) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8f228f84b1e7d967$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $8f228f84b1e7d967$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $b3d72613362f56f7$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8f228f84b1e7d967$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $8f228f84b1e7d967$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $8f228f84b1e7d967$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $8f228f84b1e7d967$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $8f228f84b1e7d967$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $8f228f84b1e7d967$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $8f228f84b1e7d967$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $8f228f84b1e7d967$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $8f228f84b1e7d967$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $8f228f84b1e7d967$export$2077e0241d6afd3c(out, a) {
    out[0] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[0]);
    out[1] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[1]);
    out[2] = $b3d72613362f56f7$export$2077e0241d6afd3c(a[2]);
    return out;
}
function $8f228f84b1e7d967$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $8f228f84b1e7d967$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $8f228f84b1e7d967$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $8f228f84b1e7d967$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $8f228f84b1e7d967$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $8f228f84b1e7d967$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $8f228f84b1e7d967$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $8f228f84b1e7d967$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $8f228f84b1e7d967$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $8f228f84b1e7d967$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $8f228f84b1e7d967$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $8f228f84b1e7d967$export$1544d9bc2995de08(out, a, b, t) {
    var angle = Math.acos(Math.min(Math.max($8f228f84b1e7d967$export$94132a0e348806d4(a, b), -1), 1));
    var sinTotal = Math.sin(angle);
    var ratioA = Math.sin((1 - t) * angle) / sinTotal;
    var ratioB = Math.sin(t * angle) / sinTotal;
    out[0] = ratioA * a[0] + ratioB * b[0];
    out[1] = ratioA * a[1] + ratioB * b[1];
    out[2] = ratioA * a[2] + ratioB * b[2];
    return out;
}
function $8f228f84b1e7d967$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8f228f84b1e7d967$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $8f228f84b1e7d967$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    var r = $b3d72613362f56f7$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $b3d72613362f56f7$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $8f228f84b1e7d967$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $8f228f84b1e7d967$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $8f228f84b1e7d967$export$c32adef9e939ce85(out, a, q) {
    // Fast Vector Rotation using Quaternions by Robert Eisele
    // https://raw.org/proof/vector-rotation-using-quaternions/
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var vx = a[0], vy = a[1], vz = a[2];
    // t = q x v
    var tx = qy * vz - qz * vy;
    var ty = qz * vx - qx * vz;
    var tz = qx * vy - qy * vx;
    // t = 2t
    tx = tx + tx;
    ty = ty + ty;
    tz = tz + tz;
    // v + w t + q x t
    out[0] = vx + qw * tx + qy * tz - qz * ty;
    out[1] = vy + qw * ty + qz * tx - qx * tz;
    out[2] = vz + qw * tz + qx * ty - qy * tx;
    return out;
}
function $8f228f84b1e7d967$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2];
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $8f228f84b1e7d967$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag = Math.sqrt((ax * ax + ay * ay + az * az) * (bx * bx + by * by + bz * bz)), cosine = mag && $8f228f84b1e7d967$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $8f228f84b1e7d967$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $8f228f84b1e7d967$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $8f228f84b1e7d967$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $8f228f84b1e7d967$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $b3d72613362f56f7$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $8f228f84b1e7d967$export$f93b5905241a7cca = $8f228f84b1e7d967$export$4e2d2ead65e5f7e3;
var $8f228f84b1e7d967$export$6e3a27864ab166fe = $8f228f84b1e7d967$export$2060d2db72cce88f;
var $8f228f84b1e7d967$export$159d9494db57879b = $8f228f84b1e7d967$export$cd007d971a5a2143;
var $8f228f84b1e7d967$export$6c4a311cc157c764 = $8f228f84b1e7d967$export$9f17032d917177de;
var $8f228f84b1e7d967$export$2422cd6c492a8b3a = $8f228f84b1e7d967$export$88e6ebb4fe54f538;
var $8f228f84b1e7d967$export$fc1400facf92c78 = $8f228f84b1e7d967$export$f24224f1c91d8156;
var $8f228f84b1e7d967$export$99d8dd3f32a3435 = $8f228f84b1e7d967$export$ab44e1323ffc8376;
var $8f228f84b1e7d967$export$4b80e395e36b5a56 = function() {
    var vec = $8f228f84b1e7d967$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();


const $243564385a18dcc8$export$33507c450926adec = `#version 300 es
precision highp float;
in vec2 a_position;
out vec2 v_uv;
void main() {
  v_uv = a_position * 0.5 + 0.5;
  gl_Position = vec4(a_position, 0.0, 1.0);
}
`;
const $243564385a18dcc8$export$125a88569be3d4c0 = `#version 300 es
precision highp float;

in vec2 v_uv;
out vec4 fragColor;

uniform float u_time;
uniform vec2 u_resolution;
uniform vec3 u_cameraPos;
uniform mat3 u_cameraMatrix;
uniform float u_blackHoleMass;
uniform float u_blackHoleSpin;
uniform int u_maxSteps;

const float PI = 3.14159265359;

float hash(vec3 p) {
  p = fract(p * 0.1031);
  p += dot(p, p.yzx + 33.33);
  return fract((p.x + p.y) * p.z);
}

vec3 starfield(vec3 rd) {
  vec3 col = vec3(0.015, 0.01, 0.025);
  col += vec3(0.12, 0.1, 0.15) * exp(-abs(rd.y) * 3.0) * 0.12;
  
  for (int layer = 0; layer < 2; layer++) {
    float scale = 90.0 + float(layer) * 70.0;
    vec3 p = rd * scale;
    vec3 id = floor(p);
    vec3 f = fract(p) - 0.5;
    float h = hash(id + float(layer) * 100.0);
    
    if (h > 0.92) {
      float brightness = (h - 0.92) * 12.5;
      float star = exp(-dot(f, f) * 80.0);
      vec3 starCol = mix(vec3(1.0, 0.8, 0.6), vec3(0.7, 0.85, 1.0), hash(id + 50.0));
      col += star * brightness * starCol;
    }
  }
  return col;
}

vec3 blackbodyColor(float t) {
  // Attempt to approximate planck's law for black body radiation
  // Higher t = hotter = bluer, lower t = cooler = redder
  vec3 c;
  c.r = clamp(t * 2.0, 0.0, 1.0);
  c.g = clamp(t * 1.5 - 0.2, 0.0, 1.0);
  c.b = clamp(t - 0.5, 0.0, 1.0);
  return mix(c, vec3(0.9, 0.95, 1.0), clamp(t - 1.2, 0.0, 0.5) * 2.0);
}

vec3 accretionDisk(vec3 pos, vec3 vel, float rs, float innerR, float outerR) {
  float r = length(pos.xz);
  if (r < innerR || r > outerR) return vec3(0.0);
  
  float invR = 1.0 / r;
  float angle = atan(pos.z, pos.x);
  
  // Keplerian orbital velocity: v = sqrt(GM/r) = sqrt(rs/(2r))
  float v = sqrt(rs * 0.5 * invR);
  vec3 orbitVel = v * vec3(-pos.z, 0.0, pos.x) * invR;
  
  // Relativistic Doppler factor: D = 1/(\u{3B3}(1 - v\xb7n\u{302}))
  // \u{3B3} = 1/sqrt(1-v\xb2) is Lorentz factor
  float vDotN = dot(orbitVel, -vel);
  float gamma = inversesqrt(max(0.01, 1.0 - v * v));
  float doppler = clamp(1.0 / (gamma * (1.0 - vDotN)), 0.2, 5.0);
  
  // Gravitational redshift: g = sqrt(1 - rs/r)
  float grav = sqrt(max(0.01, 1.0 - rs * invR));
  
  // Temperature profile: T \u{221D} r^(-3/4) (Shakura-Sunyaev thin disk)
  float temp = pow(innerR * invR, 0.75) * doppler * grav;
  vec3 col = blackbodyColor(temp);
  
  // Intensity with doppler beaming: I \u{221D} D\xb2 (simplified from D\u{2074})
  float intensity = doppler * doppler * temp;
  float pattern = 0.75 + 0.25 * sin(angle * 2.0 - log(r) * 4.0 + u_time * 0.3);
  float falloff = 1.0 - smoothstep(innerR, outerR, r);
  
  return col * intensity * pattern * falloff * 2.0;
}

vec3 trace(vec3 ro, vec3 rd, float M, float spin, int maxSteps) {
  float rs = 2.0 * M;                                            // Schwarzschild radius: rs = 2GM/c\xb2
  float rs2 = rs * rs;
  float rEvent = M + sqrt(max(0.001, M * M - spin * spin));      // Event horizon (Kerr): r+ = M + sqrt(M\xb2 - a\xb2)
  float rPhoton = 1.5 * rs;                                      // Photon sphere: r = 3GM/c\xb2 = 1.5rs
  float innerDisk = 3.0 * rs * (1.0 - 0.5 * abs(spin));          // ISCO: 6M for Schwarzschild, less for Kerr
  float outerDisk = 12.0 * rs;
  float escapeR2 = 40000.0;
  
  vec3 pos = ro;
  vec3 vel = rd;
  vec3 diskColor = vec3(0.0);
  float diskAlpha = 0.0;
  float prevY = pos.y;
  float prevR2 = dot(pos, pos);
  int diskHits = 0;
  
  for (int i = 0; i < 200; i++) {
    if (i >= maxSteps) break;
    
    float r2 = dot(pos, pos);
    float r = sqrt(r2);
    float invR = 1.0 / r;
    
    if (r2 > escapeR2) {
      return diskColor + starfield(vel) * (1.0 - diskAlpha);
    }
    
    if (r2 > prevR2 * 1.001 && r > 50.0 && abs(pos.y) > outerDisk * 0.3) {
      return diskColor + starfield(vel) * (1.0 - diskAlpha);
    }
    
    if (r < rEvent) {
      return diskColor;
    }
    
    float stepSize;
    if (r < rPhoton * 1.5) {
      stepSize = 0.03 * r;
    } else if (r < 20.0 * rs) {
      stepSize = 0.15 * r * invR * rs;
    } else {
      stepSize = 0.5 + r * 0.02;
    }
    
    float y = pos.y;
    if (diskHits < 2 && abs(y) < outerDisk * 0.5) {
      if (prevY * y < 0.0) {
        float t = abs(prevY) / (abs(prevY) + abs(y) + 0.0001);
        vec3 hitPos = pos - vel * stepSize * (1.0 - t);
        vec3 dc = accretionDisk(hitPos, vel, rs, innerDisk, outerDisk);
        float lum = dot(dc, vec3(0.3, 0.5, 0.2));
        if (lum > 0.001) {
          diskColor += dc * (1.0 - diskAlpha);
          diskAlpha = min(diskAlpha + 0.6, 0.95);
          diskHits++;
        }
      }
    }
    prevY = y;
    prevR2 = r2;
    
    // Geodesic equation for null rays in Schwarzschild metric
    // d\xb2r/d\u{3BB}\xb2 = -\u{393}\u{2B3}\u{209C}\u{209C}(dt/d\u{3BB})\xb2 - \u{393}\u{2B3}\u{1D63}\u{1D63}(dr/d\u{3BB})\xb2 - \u{393}\u{2B3}\u{3B8}\u{3B8}(d\u{3B8}/d\u{3BB})\xb2 - \u{393}\u{2B3}\u{3C6}\u{3C6}(d\u{3C6}/d\u{3BB})\xb2
    // Simplifies to: a = -1.5 * rs * h\xb2/r\u{2074} * r\u{302}
    // where h = |r \xd7 v| is specific angular momentum
    vec3 L = cross(pos, vel);
    float h2 = dot(L, L);
    float r4 = r2 * r2;
    float accelMag = 1.5 * rs * h2 / r4;
    vec3 rhat = pos * invR;
    vec3 accel = -accelMag * rhat;
    
    // Frame dragging (Lense-Thirring): \u{3A9} = 2Ma/r\xb3
    // Adds precession to orbits around spinning black hole
    if (abs(spin) > 0.05) {
      accel += cross(vec3(0.0, 1.0, 0.0), vel) * (2.0 * spin * rs2 / (r2 * r));
    }
    
    // Leapfrog integration: x(t+dt) = x(t) + v(t)dt + 0.5a(t)dt\xb2
    vel += accel * stepSize;
    pos += vel * stepSize;
    vel = normalize(vel);
  }
  
  return diskColor + starfield(vel) * (1.0 - diskAlpha);
}

void main() {
  vec2 uv = (gl_FragCoord.xy - 0.5 * u_resolution) / u_resolution.y;
  
  vec3 ro = u_cameraPos;
  vec3 rd = normalize(u_cameraMatrix * vec3(uv, 1.0));
  
  float M = u_blackHoleMass;
  float spin = u_blackHoleSpin * M * 0.99;
  
  vec3 color = trace(ro, rd, M, spin, u_maxSteps);
  
  // ACES tonemapping: attempt to map hdr values to ldr output
  color = color * (color + 0.1) / (color * 0.9 + 0.3);
  color = pow(clamp(color, 0.0, 1.0), vec3(0.45));
  color *= 1.0 - dot(v_uv - 0.5, v_uv - 0.5) * 0.3;
  
  fragColor = vec4(color, 1.0);
}
`;


let $cc043e86fa645268$var$gl, $cc043e86fa645268$var$mainProgram, $cc043e86fa645268$var$bloomProgram, $cc043e86fa645268$var$compositeProgram, $cc043e86fa645268$var$mainVao;
let $cc043e86fa645268$var$framebuffers = {};
const $cc043e86fa645268$var$camera = {
    distance: 40.0,
    theta: 0.0,
    phi: Math.PI / 2.5,
    autoRotate: true,
    rotateSpeed: 0.08
};
const $cc043e86fa645268$var$mouse = {
    down: false,
    x: 0,
    y: 0
};
const $cc043e86fa645268$var$QUALITY = {
    low: {
        resolution: 0.35,
        maxSteps: 80,
        bloomRes: 0.125,
        bloomPasses: 1
    },
    medium: {
        resolution: 0.5,
        maxSteps: 120,
        bloomRes: 0.2,
        bloomPasses: 1
    },
    high: {
        resolution: 0.75,
        maxSteps: 160,
        bloomRes: 0.25,
        bloomPasses: 2
    },
    ultra: {
        resolution: 1.0,
        maxSteps: 200,
        bloomRes: 0.33,
        bloomPasses: 2
    }
};
const $cc043e86fa645268$var$params = {
    mass: 1.0,
    spin: 0.0,
    quality: 'medium',
    bloom: true,
    bloomStrength: 0.35
};
const $cc043e86fa645268$var$bloomBlurShader = `#version 300 es
precision mediump float;
in vec2 v_uv;
out vec4 fragColor;
uniform sampler2D u_texture;
uniform vec2 u_direction;
uniform vec2 u_texelSize;

void main() {
  vec3 result = texture(u_texture, v_uv).rgb * 0.29;
  vec2 off1 = u_direction * u_texelSize * 1.5;
  vec2 off2 = u_direction * u_texelSize * 3.5;
  result += (texture(u_texture, v_uv + off1).rgb + texture(u_texture, v_uv - off1).rgb) * 0.23;
  result += (texture(u_texture, v_uv + off2).rgb + texture(u_texture, v_uv - off2).rgb) * 0.12;
  fragColor = vec4(result, 1.0);
}`;
const $cc043e86fa645268$var$compositeShader = `#version 300 es
precision mediump float;
in vec2 v_uv;
out vec4 fragColor;
uniform sampler2D u_scene;
uniform sampler2D u_bloom;
uniform float u_bloomStrength;

void main() {
  vec3 scene = texture(u_scene, v_uv).rgb;
  vec3 bloom = texture(u_bloom, v_uv).rgb;
  fragColor = vec4(scene + bloom * u_bloomStrength, 1.0);
}`;
function $cc043e86fa645268$var$createShader(type, source) {
    const shader = $cc043e86fa645268$var$gl.createShader(type);
    $cc043e86fa645268$var$gl.shaderSource(shader, source);
    $cc043e86fa645268$var$gl.compileShader(shader);
    if (!$cc043e86fa645268$var$gl.getShaderParameter(shader, $cc043e86fa645268$var$gl.COMPILE_STATUS)) {
        console.error('Shader error:', $cc043e86fa645268$var$gl.getShaderInfoLog(shader));
        return null;
    }
    return shader;
}
function $cc043e86fa645268$var$createProgram(vsSource, fsSource) {
    const vs = $cc043e86fa645268$var$createShader($cc043e86fa645268$var$gl.VERTEX_SHADER, vsSource);
    const fs = $cc043e86fa645268$var$createShader($cc043e86fa645268$var$gl.FRAGMENT_SHADER, fsSource);
    if (!vs || !fs) return null;
    const program = $cc043e86fa645268$var$gl.createProgram();
    $cc043e86fa645268$var$gl.attachShader(program, vs);
    $cc043e86fa645268$var$gl.attachShader(program, fs);
    $cc043e86fa645268$var$gl.linkProgram(program);
    if (!$cc043e86fa645268$var$gl.getProgramParameter(program, $cc043e86fa645268$var$gl.LINK_STATUS)) {
        console.error('Program error:', $cc043e86fa645268$var$gl.getProgramInfoLog(program));
        return null;
    }
    return program;
}
function $cc043e86fa645268$var$createFramebuffer(width, height, useFloat = true) {
    const texture = $cc043e86fa645268$var$gl.createTexture();
    $cc043e86fa645268$var$gl.bindTexture($cc043e86fa645268$var$gl.TEXTURE_2D, texture);
    if (useFloat) $cc043e86fa645268$var$gl.texImage2D($cc043e86fa645268$var$gl.TEXTURE_2D, 0, $cc043e86fa645268$var$gl.RGBA16F, width, height, 0, $cc043e86fa645268$var$gl.RGBA, $cc043e86fa645268$var$gl.FLOAT, null);
    else $cc043e86fa645268$var$gl.texImage2D($cc043e86fa645268$var$gl.TEXTURE_2D, 0, $cc043e86fa645268$var$gl.RGBA, width, height, 0, $cc043e86fa645268$var$gl.RGBA, $cc043e86fa645268$var$gl.UNSIGNED_BYTE, null);
    $cc043e86fa645268$var$gl.texParameteri($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$gl.TEXTURE_MIN_FILTER, $cc043e86fa645268$var$gl.LINEAR);
    $cc043e86fa645268$var$gl.texParameteri($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$gl.TEXTURE_MAG_FILTER, $cc043e86fa645268$var$gl.LINEAR);
    $cc043e86fa645268$var$gl.texParameteri($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$gl.TEXTURE_WRAP_S, $cc043e86fa645268$var$gl.CLAMP_TO_EDGE);
    $cc043e86fa645268$var$gl.texParameteri($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$gl.TEXTURE_WRAP_T, $cc043e86fa645268$var$gl.CLAMP_TO_EDGE);
    const fb = $cc043e86fa645268$var$gl.createFramebuffer();
    $cc043e86fa645268$var$gl.bindFramebuffer($cc043e86fa645268$var$gl.FRAMEBUFFER, fb);
    $cc043e86fa645268$var$gl.framebufferTexture2D($cc043e86fa645268$var$gl.FRAMEBUFFER, $cc043e86fa645268$var$gl.COLOR_ATTACHMENT0, $cc043e86fa645268$var$gl.TEXTURE_2D, texture, 0);
    $cc043e86fa645268$var$gl.bindFramebuffer($cc043e86fa645268$var$gl.FRAMEBUFFER, null);
    return {
        framebuffer: fb,
        texture: texture,
        width: width,
        height: height
    };
}
function $cc043e86fa645268$var$init(canvas) {
    $cc043e86fa645268$var$gl = canvas.getContext('webgl2', {
        antialias: false,
        alpha: false,
        powerPreference: 'high-performance',
        preserveDrawingBuffer: false
    });
    if (!$cc043e86fa645268$var$gl) throw new Error('WebGL2 not supported');
    $cc043e86fa645268$var$gl.getExtension('EXT_color_buffer_float');
    $cc043e86fa645268$var$mainProgram = $cc043e86fa645268$var$createProgram((0, $243564385a18dcc8$export$33507c450926adec), (0, $243564385a18dcc8$export$125a88569be3d4c0));
    $cc043e86fa645268$var$bloomProgram = $cc043e86fa645268$var$createProgram((0, $243564385a18dcc8$export$33507c450926adec), $cc043e86fa645268$var$bloomBlurShader);
    $cc043e86fa645268$var$compositeProgram = $cc043e86fa645268$var$createProgram((0, $243564385a18dcc8$export$33507c450926adec), $cc043e86fa645268$var$compositeShader);
    $cc043e86fa645268$var$mainVao = $cc043e86fa645268$var$gl.createVertexArray();
    $cc043e86fa645268$var$gl.bindVertexArray($cc043e86fa645268$var$mainVao);
    const buf = $cc043e86fa645268$var$gl.createBuffer();
    $cc043e86fa645268$var$gl.bindBuffer($cc043e86fa645268$var$gl.ARRAY_BUFFER, buf);
    $cc043e86fa645268$var$gl.bufferData($cc043e86fa645268$var$gl.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        1
    ]), $cc043e86fa645268$var$gl.STATIC_DRAW);
    [
        $cc043e86fa645268$var$mainProgram,
        $cc043e86fa645268$var$bloomProgram,
        $cc043e86fa645268$var$compositeProgram
    ].forEach((prog)=>{
        if (prog) {
            const loc = $cc043e86fa645268$var$gl.getAttribLocation(prog, 'a_position');
            if (loc >= 0) {
                $cc043e86fa645268$var$gl.enableVertexAttribArray(loc);
                $cc043e86fa645268$var$gl.vertexAttribPointer(loc, 2, $cc043e86fa645268$var$gl.FLOAT, false, 0, 0);
            }
        }
    });
    $cc043e86fa645268$var$mainProgram.u = {
        time: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_time'),
        resolution: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_resolution'),
        cameraPos: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_cameraPos'),
        cameraMatrix: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_cameraMatrix'),
        blackHoleMass: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_blackHoleMass'),
        blackHoleSpin: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_blackHoleSpin'),
        maxSteps: $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$mainProgram, 'u_maxSteps')
    };
}
function $cc043e86fa645268$var$getCameraPosition() {
    const sp = Math.sin($cc043e86fa645268$var$camera.phi), cp = Math.cos($cc043e86fa645268$var$camera.phi);
    const st = Math.sin($cc043e86fa645268$var$camera.theta), ct = Math.cos($cc043e86fa645268$var$camera.theta);
    return [
        $cc043e86fa645268$var$camera.distance * sp * ct,
        $cc043e86fa645268$var$camera.distance * cp,
        $cc043e86fa645268$var$camera.distance * sp * st
    ];
}
function $cc043e86fa645268$var$getCameraMatrix() {
    const pos = $cc043e86fa645268$var$getCameraPosition();
    const forward = (0, $8f228f84b1e7d967$exports).create();
    (0, $8f228f84b1e7d967$exports).normalize(forward, (0, $8f228f84b1e7d967$exports).negate(forward, pos));
    const right = (0, $8f228f84b1e7d967$exports).create();
    (0, $8f228f84b1e7d967$exports).normalize(right, (0, $8f228f84b1e7d967$exports).cross(right, forward, [
        0,
        1,
        0
    ]));
    const up = (0, $8f228f84b1e7d967$exports).create();
    (0, $8f228f84b1e7d967$exports).cross(up, right, forward);
    return new Float32Array([
        right[0],
        right[1],
        right[2],
        up[0],
        up[1],
        up[2],
        forward[0],
        forward[1],
        forward[2]
    ]);
}
let $cc043e86fa645268$var$lastWidth = 0, $cc043e86fa645268$var$lastHeight = 0;
function $cc043e86fa645268$var$resize() {
    const canvas = $cc043e86fa645268$var$gl.canvas;
    const preset = $cc043e86fa645268$var$QUALITY[$cc043e86fa645268$var$params.quality];
    const dpr = Math.min(window.devicePixelRatio, 2) * preset.resolution;
    const w = Math.floor(canvas.clientWidth * dpr);
    const h = Math.floor(canvas.clientHeight * dpr);
    if (w !== $cc043e86fa645268$var$lastWidth || h !== $cc043e86fa645268$var$lastHeight) {
        canvas.width = w;
        canvas.height = h;
        $cc043e86fa645268$var$lastWidth = w;
        $cc043e86fa645268$var$lastHeight = h;
        const bloomW = Math.max(1, Math.floor(w * preset.bloomRes));
        const bloomH = Math.max(1, Math.floor(h * preset.bloomRes));
        $cc043e86fa645268$var$framebuffers.scene = $cc043e86fa645268$var$createFramebuffer(w, h);
        $cc043e86fa645268$var$framebuffers.bloom1 = $cc043e86fa645268$var$createFramebuffer(bloomW, bloomH, false);
        $cc043e86fa645268$var$framebuffers.bloom2 = $cc043e86fa645268$var$createFramebuffer(bloomW, bloomH, false);
    }
}
function $cc043e86fa645268$var$render(time) {
    time *= 0.001;
    $cc043e86fa645268$var$resize();
    if ($cc043e86fa645268$var$camera.autoRotate) $cc043e86fa645268$var$camera.theta += $cc043e86fa645268$var$camera.rotateSpeed * 0.016;
    const preset = $cc043e86fa645268$var$QUALITY[$cc043e86fa645268$var$params.quality];
    const w = $cc043e86fa645268$var$gl.canvas.width;
    const h = $cc043e86fa645268$var$gl.canvas.height;
    $cc043e86fa645268$var$gl.bindVertexArray($cc043e86fa645268$var$mainVao);
    const target = $cc043e86fa645268$var$params.bloom ? $cc043e86fa645268$var$framebuffers.scene.framebuffer : null;
    $cc043e86fa645268$var$gl.bindFramebuffer($cc043e86fa645268$var$gl.FRAMEBUFFER, target);
    $cc043e86fa645268$var$gl.viewport(0, 0, w, h);
    $cc043e86fa645268$var$gl.useProgram($cc043e86fa645268$var$mainProgram);
    const u = $cc043e86fa645268$var$mainProgram.u;
    $cc043e86fa645268$var$gl.uniform1f(u.time, time);
    $cc043e86fa645268$var$gl.uniform2f(u.resolution, w, h);
    $cc043e86fa645268$var$gl.uniform3fv(u.cameraPos, $cc043e86fa645268$var$getCameraPosition());
    $cc043e86fa645268$var$gl.uniformMatrix3fv(u.cameraMatrix, false, $cc043e86fa645268$var$getCameraMatrix());
    $cc043e86fa645268$var$gl.uniform1f(u.blackHoleMass, $cc043e86fa645268$var$params.mass);
    $cc043e86fa645268$var$gl.uniform1f(u.blackHoleSpin, $cc043e86fa645268$var$params.spin);
    $cc043e86fa645268$var$gl.uniform1i(u.maxSteps, preset.maxSteps);
    $cc043e86fa645268$var$gl.drawArrays($cc043e86fa645268$var$gl.TRIANGLE_STRIP, 0, 4);
    if ($cc043e86fa645268$var$params.bloom && $cc043e86fa645268$var$bloomProgram && $cc043e86fa645268$var$compositeProgram) {
        const bw = $cc043e86fa645268$var$framebuffers.bloom1.width;
        const bh = $cc043e86fa645268$var$framebuffers.bloom1.height;
        $cc043e86fa645268$var$gl.useProgram($cc043e86fa645268$var$bloomProgram);
        $cc043e86fa645268$var$gl.viewport(0, 0, bw, bh);
        const texelLoc = $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$bloomProgram, 'u_texelSize');
        const dirLoc = $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$bloomProgram, 'u_direction');
        const texLoc = $cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$bloomProgram, 'u_texture');
        $cc043e86fa645268$var$gl.uniform2f(texelLoc, 1.0 / bw, 1.0 / bh);
        $cc043e86fa645268$var$gl.uniform1i(texLoc, 0);
        $cc043e86fa645268$var$gl.activeTexture($cc043e86fa645268$var$gl.TEXTURE0);
        for(let pass = 0; pass < preset.bloomPasses; pass++){
            $cc043e86fa645268$var$gl.bindFramebuffer($cc043e86fa645268$var$gl.FRAMEBUFFER, $cc043e86fa645268$var$framebuffers.bloom1.framebuffer);
            $cc043e86fa645268$var$gl.bindTexture($cc043e86fa645268$var$gl.TEXTURE_2D, pass === 0 ? $cc043e86fa645268$var$framebuffers.scene.texture : $cc043e86fa645268$var$framebuffers.bloom2.texture);
            $cc043e86fa645268$var$gl.uniform2f(dirLoc, 1.0 + pass, 0.0);
            $cc043e86fa645268$var$gl.drawArrays($cc043e86fa645268$var$gl.TRIANGLE_STRIP, 0, 4);
            $cc043e86fa645268$var$gl.bindFramebuffer($cc043e86fa645268$var$gl.FRAMEBUFFER, $cc043e86fa645268$var$framebuffers.bloom2.framebuffer);
            $cc043e86fa645268$var$gl.bindTexture($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$framebuffers.bloom1.texture);
            $cc043e86fa645268$var$gl.uniform2f(dirLoc, 0.0, 1.0 + pass);
            $cc043e86fa645268$var$gl.drawArrays($cc043e86fa645268$var$gl.TRIANGLE_STRIP, 0, 4);
        }
        $cc043e86fa645268$var$gl.bindFramebuffer($cc043e86fa645268$var$gl.FRAMEBUFFER, null);
        $cc043e86fa645268$var$gl.viewport(0, 0, w, h);
        $cc043e86fa645268$var$gl.useProgram($cc043e86fa645268$var$compositeProgram);
        $cc043e86fa645268$var$gl.activeTexture($cc043e86fa645268$var$gl.TEXTURE0);
        $cc043e86fa645268$var$gl.bindTexture($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$framebuffers.scene.texture);
        $cc043e86fa645268$var$gl.uniform1i($cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$compositeProgram, 'u_scene'), 0);
        $cc043e86fa645268$var$gl.activeTexture($cc043e86fa645268$var$gl.TEXTURE1);
        $cc043e86fa645268$var$gl.bindTexture($cc043e86fa645268$var$gl.TEXTURE_2D, $cc043e86fa645268$var$framebuffers.bloom2.texture);
        $cc043e86fa645268$var$gl.uniform1i($cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$compositeProgram, 'u_bloom'), 1);
        $cc043e86fa645268$var$gl.uniform1f($cc043e86fa645268$var$gl.getUniformLocation($cc043e86fa645268$var$compositeProgram, 'u_bloomStrength'), $cc043e86fa645268$var$params.bloomStrength);
        $cc043e86fa645268$var$gl.drawArrays($cc043e86fa645268$var$gl.TRIANGLE_STRIP, 0, 4);
    }
    requestAnimationFrame($cc043e86fa645268$var$render);
}
function $cc043e86fa645268$var$setupControls(canvas) {
    canvas.addEventListener('mousedown', (e)=>{
        $cc043e86fa645268$var$mouse.down = true;
        $cc043e86fa645268$var$mouse.x = e.clientX;
        $cc043e86fa645268$var$mouse.y = e.clientY;
        $cc043e86fa645268$var$camera.autoRotate = false;
    });
    canvas.addEventListener('mousemove', (e)=>{
        if (!$cc043e86fa645268$var$mouse.down) return;
        $cc043e86fa645268$var$camera.theta -= (e.clientX - $cc043e86fa645268$var$mouse.x) * 0.005;
        $cc043e86fa645268$var$camera.phi = Math.max(0.1, Math.min(Math.PI - 0.1, $cc043e86fa645268$var$camera.phi + (e.clientY - $cc043e86fa645268$var$mouse.y) * 0.005));
        $cc043e86fa645268$var$mouse.x = e.clientX;
        $cc043e86fa645268$var$mouse.y = e.clientY;
    });
    canvas.addEventListener('mouseup', ()=>$cc043e86fa645268$var$mouse.down = false);
    canvas.addEventListener('mouseleave', ()=>$cc043e86fa645268$var$mouse.down = false);
    canvas.addEventListener('wheel', (e)=>{
        e.preventDefault();
        $cc043e86fa645268$var$camera.distance = Math.max(8, Math.min(150, $cc043e86fa645268$var$camera.distance * (1 + e.deltaY * 0.001)));
    }, {
        passive: false
    });
    let touchDist = 0;
    canvas.addEventListener('touchstart', (e)=>{
        e.preventDefault();
        $cc043e86fa645268$var$camera.autoRotate = false;
        if (e.touches.length === 1) {
            $cc043e86fa645268$var$mouse.x = e.touches[0].clientX;
            $cc043e86fa645268$var$mouse.y = e.touches[0].clientY;
        } else if (e.touches.length === 2) {
            const dx = e.touches[1].clientX - e.touches[0].clientX;
            const dy = e.touches[1].clientY - e.touches[0].clientY;
            touchDist = Math.hypot(dx, dy);
        }
    }, {
        passive: false
    });
    canvas.addEventListener('touchmove', (e)=>{
        e.preventDefault();
        if (e.touches.length === 1) {
            $cc043e86fa645268$var$camera.theta -= (e.touches[0].clientX - $cc043e86fa645268$var$mouse.x) * 0.005;
            $cc043e86fa645268$var$camera.phi = Math.max(0.1, Math.min(Math.PI - 0.1, $cc043e86fa645268$var$camera.phi + (e.touches[0].clientY - $cc043e86fa645268$var$mouse.y) * 0.005));
            $cc043e86fa645268$var$mouse.x = e.touches[0].clientX;
            $cc043e86fa645268$var$mouse.y = e.touches[0].clientY;
        } else if (e.touches.length === 2) {
            const dx = e.touches[1].clientX - e.touches[0].clientX;
            const dy = e.touches[1].clientY - e.touches[0].clientY;
            const dist = Math.hypot(dx, dy);
            $cc043e86fa645268$var$camera.distance = Math.max(8, Math.min(150, $cc043e86fa645268$var$camera.distance * touchDist / dist));
            touchDist = dist;
        }
    }, {
        passive: false
    });
    canvas.addEventListener('dblclick', ()=>{
        $cc043e86fa645268$var$camera.distance = 40;
        $cc043e86fa645268$var$camera.theta = 0;
        $cc043e86fa645268$var$camera.phi = Math.PI / 2.5;
        $cc043e86fa645268$var$camera.autoRotate = true;
    });
    window.addEventListener('keydown', (e)=>{
        const key = e.key.toLowerCase();
        switch(key){
            case ' ':
                e.preventDefault();
                $cc043e86fa645268$var$camera.autoRotate = !$cc043e86fa645268$var$camera.autoRotate;
                break;
            case 'arrowup':
                $cc043e86fa645268$var$params.spin = Math.min(0.99, $cc043e86fa645268$var$params.spin + 0.1);
                console.log(`Spin: ${($cc043e86fa645268$var$params.spin * 100).toFixed(0)}%`);
                break;
            case 'arrowdown':
                $cc043e86fa645268$var$params.spin = Math.max(0, $cc043e86fa645268$var$params.spin - 0.1);
                console.log(`Spin: ${($cc043e86fa645268$var$params.spin * 100).toFixed(0)}%`);
                break;
            case 'arrowright':
                $cc043e86fa645268$var$params.mass = Math.min(3, $cc043e86fa645268$var$params.mass + 0.2);
                console.log(`Mass: ${$cc043e86fa645268$var$params.mass.toFixed(1)}M`);
                break;
            case 'arrowleft':
                $cc043e86fa645268$var$params.mass = Math.max(0.5, $cc043e86fa645268$var$params.mass - 0.2);
                console.log(`Mass: ${$cc043e86fa645268$var$params.mass.toFixed(1)}M`);
                break;
            case '1':
                $cc043e86fa645268$var$params.quality = 'low';
                $cc043e86fa645268$var$lastWidth = 0;
                console.log('Quality: LOW');
                break;
            case '2':
                $cc043e86fa645268$var$params.quality = 'medium';
                $cc043e86fa645268$var$lastWidth = 0;
                console.log('Quality: MEDIUM');
                break;
            case '3':
                $cc043e86fa645268$var$params.quality = 'high';
                $cc043e86fa645268$var$lastWidth = 0;
                console.log('Quality: HIGH');
                break;
            case '4':
                $cc043e86fa645268$var$params.quality = 'ultra';
                $cc043e86fa645268$var$lastWidth = 0;
                console.log('Quality: ULTRA');
                break;
            case 'b':
                $cc043e86fa645268$var$params.bloom = !$cc043e86fa645268$var$params.bloom;
                console.log(`Bloom: ${$cc043e86fa645268$var$params.bloom ? 'ON' : 'OFF'}`);
                break;
            case '=':
            case '+':
                $cc043e86fa645268$var$params.bloomStrength = Math.min(1.5, $cc043e86fa645268$var$params.bloomStrength + 0.1);
                console.log(`Bloom: ${$cc043e86fa645268$var$params.bloomStrength.toFixed(1)}`);
                break;
            case '-':
                $cc043e86fa645268$var$params.bloomStrength = Math.max(0, $cc043e86fa645268$var$params.bloomStrength - 0.1);
                console.log(`Bloom: ${$cc043e86fa645268$var$params.bloomStrength.toFixed(1)}`);
                break;
            case 'r':
                Object.assign($cc043e86fa645268$var$camera, {
                    distance: 40,
                    theta: 0,
                    phi: Math.PI / 2.5,
                    autoRotate: true
                });
                Object.assign($cc043e86fa645268$var$params, {
                    mass: 1,
                    spin: 0,
                    quality: 'medium',
                    bloom: true,
                    bloomStrength: 0.35
                });
                $cc043e86fa645268$var$lastWidth = 0;
                console.log('Reset');
                break;
        }
    });
}
const $cc043e86fa645268$var$canvas = document.getElementById('canvas');
try {
    $cc043e86fa645268$var$init($cc043e86fa645268$var$canvas);
    $cc043e86fa645268$var$setupControls($cc043e86fa645268$var$canvas);
    requestAnimationFrame($cc043e86fa645268$var$render);
    console.log("%c\u2605 Black Hole \u2605", 'font-size:18px;font-weight:bold;color:#f80');
    console.log('Drag/Scroll: Camera | Space: Auto-rotate');
    console.log("\u2191/\u2193: Spin | \u2190/\u2192: Mass | 1-4: Quality | B: Bloom | R: Reset");
} catch (e) {
    console.error('Init failed:', e);
}


//# sourceMappingURL=blackhole.ba4ff0a1.js.map
